import { cn } from '@/lib/utils';
import * as Collapsible from '@radix-ui/react-collapsible';
import { ChevronUp, InfoIcon } from 'lucide-react';
import React, { useState } from 'react';
import { Text } from './text';
import { Tooltip, TooltipContent, TooltipTrigger } from './tooltip';

interface Props extends React.PropsWithChildren {
    title: string;
    defaultOpen?: boolean;
    tooltipText?: string;
    className?: string;
}

export const CollapsibleContainer = ({
    defaultOpen = false,
    tooltipText,
    title,
    children,
    className,
}: Props) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <Collapsible.Root
            defaultOpen={defaultOpen}
            open={isOpen}
            onOpenChange={setIsOpen}
            className={className}
        >
            <Collapsible.Trigger>
                <span className="flex flex-row items-center">
                    <span
                        style={{ transformOrigin: 'center' }}
                        className={cn('p-2 duration-200', {
                            'rotate-180': isOpen,
                        })}
                    >
                        <ChevronUp />
                    </span>
                    <div className="flex flex-row gap-x-2 items-center">
                        <Text>{title}</Text>
                        {tooltipText && (
                            <Tooltip>
                                <TooltipTrigger>
                                    <span className="flex h-4 w-4 items-center justify-center rounded-full bg-neutral-100">
                                        <InfoIcon />
                                    </span>
                                </TooltipTrigger>
                                <TooltipContent side="right">{tooltipText}</TooltipContent>
                            </Tooltip>
                        )}
                    </div>
                </span>
            </Collapsible.Trigger>
            <Collapsible.Content>{children}</Collapsible.Content>
        </Collapsible.Root>
    );
};
